import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/process-result.style.css';
import logo from '../assets/images/logo.png';
import mascotResultLoading from '../assets/images/mascot-result-loading.png';
import mascotResultShadow from '../assets/images/main-shadow.png';
import mascotHairLeft from '../assets/images/process-hair-1.png';
import mascotHairRight from '../assets/images/process-hair-2.png';
import mascotStarPink from '../assets/images/star-pink.svg';
import mascotStarGreen from '../assets/images/star-green.svg';
import mascotHairYellow from '../assets/images/hair-yellow.png';
import mascotHairYellowStar from '../assets/images/hair-yellow-star.png';
import scoutoutLogo from '../assets/images/scoutout-logo.png';
const ProcessResultPage = () => {
    const navigate = useNavigate();
    const { t } = useLanguage();

    
    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/result');
        }, 3000);
        
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className='container'>
            <div className='container-fluid-process-result'>
                <div className='process-result-page'>
                    <div className='mascot-control-process-result'>
                        <img src={mascotResultLoading} alt='mascotResultLoading' className='mascot-img-process-result' />
                        <img src={mascotResultShadow}  className='mascot-img-process-result-shadow' />
                        <img src={mascotHairLeft} alt='mascotHairLeft' className='mascot-img-process-result-hair-left' />
                        <img src={mascotHairRight} alt='mascotHairRight' className='mascot-img-process-result-hair-right' />
                        <img src={mascotStarPink} alt='mascotStarPink' className='mascot-img-process-result-star-pink' />
                        <img src={mascotStarGreen} alt='mascotStarGreen' className='mascot-img-process-result-star-green' />
                        <img src={mascotHairYellow} alt='mascotHairYellow' className='mascot-img-process-result-hair-yellow' />
                        <img src={mascotHairYellowStar} alt='mascotHairYellowStar' className='mascot-img-process-result-hair-yellow-star' />
                    </div>
                    <span className='process-result-text'>{t('processResult.text')}</span>
                    <div className='process-result-bottom-control'>
                        <img src={logo} alt='logo' className='logo-white' />
                        <h1 className='head-title-process-result' dangerouslySetInnerHTML={{ __html: t('home.title') }}></h1>
                        <h1 className='head-title-process-result-2' dangerouslySetInnerHTML={{ __html: t('home.title2') }}></h1>
                        <div className='powered-by-text-process-result'><span className='powered-by-text-process-result-text'>{t('home.poweredBy')}</span>
                            <img src={scoutoutLogo} alt='logo' className='powered-by-text-process-result-logo' /> Interview AI
                        </div>

                    </div>


                </div>
            </div>
        </div>
    );
}

export default ProcessResultPage